import React from "react";

const Logo = (props: any) => {
    return <div style={{width: 30, height: 30, overflow: "hidden", ...props.styles || {}}} onClick={() => props?.onClick?.()}>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 207.23 207.23">
            <path className="topLogo" fill="#5474b4" d="M74.23,118.77C63.3,104,61.05,87.49,64.21,70S77.1,38.9,91.35,27.35c-18.33,2-53.81,26.89-66.49,58.1-12,29.58-9.69,58.48,3.6,87.62a27.3,27.3,0,0,1-4.12-3.4C8.7,150.65.19,128.88,0,104.18-.22,74.82,10,49.41,31.08,29,78.42-16.81,156-7,190.8,48.89a15.11,15.11,0,0,1,1.55,2.69c.94,2.57,1.74,5.19,2.6,7.79-1.91-1.7-4-3.27-5.71-5.12-24-25.61-62.52-31.32-91.72-8.23-18,14.27-26.39,33.34-25.76,56.21C71.91,107.76,73.37,113.25,74.23,118.77Z" />
            <path fill="#000" d="M54.76,59.75c-3.28,10.38-6.84,18.73-8.51,27.44-7.65,40,11.14,80.31,49.08,96.16,27.56,11.51,53.55,7.15,77.25-10.94,1.23-.94,2.27-2.13,3.54-3,.43-.29,1.33,0,1.93.18.17.07.19,1,0,1.41a18.07,18.07,0,0,1-1.58,2.64,77.83,77.83,0,0,1-116.2,13.51c-17.87-16.09-28-35.9-29.87-60.07-1.82-23.85,5-44.74,20-63.17C51.3,62.79,52.51,61.88,54.76,59.75Z" />
        </svg>
    </div>
}

export default Logo
